import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import partner1 from "@/assets/partner-logo-1.png";
import partner2 from "@/assets/partner-logo-2.png";
import partner3 from "@/assets/partner-logo-3.png";
import partner4 from "@/assets/partner-logo-4.png";
import partner5 from "@/assets/partner-logo-5.png";
import partner6 from "@/assets/partner-logo-6.png";
import partner7 from "@/assets/partner-logo-7.png";
import partner8 from "@/assets/partner-logo-8.png";
import partner9 from "@/assets/partner-logo-9.png";

const partners = [
  partner1,
  partner2,
  partner3,
  partner4,
  partner5,
  partner6,
  partner7,
  partner8,
  partner9,
];

const Partners = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 relative overflow-hidden border-y border-border/50">
      <div className="container mx-auto px-6 mb-12">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center font-heading text-2xl font-bold text-muted-foreground"
        >
          {t("partners.title")}
        </motion.h3>
      </div>

      {/* Marquee Container */}
      <div className="relative">
        <div className="flex animate-marquee whitespace-nowrap">
          {[...partners, ...partners].map((partner, index) => (
            <div
              key={index}
              className="mx-8 flex-shrink-0 flex items-center h-16"
            >
              <img 
                src={partner} 
                alt={`Partner ${index + 1}`}
                loading="lazy"
                decoding="async"
                className="h-full w-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
        
        {/* Gradient overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent pointer-events-none" />
      </div>
    </section>
  );
};

export default Partners;
